export default __webpack_public_path__ + "static/media/Understanding.45c3d7b9.jpg";